import React from 'react';
import { Input, Grid } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';
import { getAllGlobalTaskAttributesSelector } from '../../../../generalConfig/attributeManagement/redux/reducer';

const AttributeComponent = ({ matrixList, task }) => {
  const taskAttributes = useSelector(getAllGlobalTaskAttributesSelector);
  const taskAttributeDict = _.keyBy(taskAttributes, 'attributeName', {});
  const uniqMatrixList = _.uniqBy(matrixList, 'id');
  return (
    <Grid columns="equal">
      {(uniqMatrixList || []).map((matrix) => (
        <Grid.Column key={matrix.attributeKey}>
          <label>
            {_.get(taskAttributeDict, `${matrix.attributeKey}.attributeDisplayName`, '').toUpperCase() || ''}
          </label>
          <br />
          <Input disabled value={_.get(task, `globalAttributes.${matrix.attributeKey}`)} />
        </Grid.Column>
      ))}
    </Grid>
  );
};

export default AttributeComponent;
